import { useEffect, useState, useContext, useRef } from "react";
import { CurrentPContext, UserContext, MasterContext } from "../../../ContextApi/context";
import DatePick2 from "./DatePick2";
import { format, isToday } from 'date-fns';
import MyDateTime from "../../../DTechComp/MyDateTime";
import TimesListSelections from "./TimesListSelections";
import DinnersNumbSelect from "./DinnersNumbSelect";
import utilsTblOrders from "../../../_Utils/utilsTblOrders";
import SpecialRequests from "./SpecialRequests";
import PopUpClearComp from "../../../DTechComp/PopUpClearComp";
import LoginPage from "../../../UsersLogs/LoginPage";
import ApprovedOrdr from "./ApprovedOrdr";
import PopUpTheComp from "../../../DTechComp/PopUpTheComp";
import Table_Order_Confirmd from "../../../DTechComp/Pop_Fixed/Table_Order_Confirmd";

const TblOrderReservation = (props) => {

    const [currentPage, setCurrentPage] = useContext(CurrentPContext);
    const [user, setUser] = useContext(UserContext);
    //דרוש בשביל חריגות גלובליות - יום חריג שהוגדר במאסטר חוסם
    //תאריכי הזמנת שולחן בכל העסקים, לא רק הזמנות אוכל
    const [master] = useContext(MasterContext);
    const [thePopUp, setThePopUp] = useState("");
    const [dispDate, setDispDate] = useState(false)
    const [dispTime, setDispTime] = useState(false)
    const [dispDinners, setDispDinners] = useState(true)
    const [dispTableOpts, setDispTableOpts] = useState(false)
    const [panelDisp, setPanelDisp] = useState("")

    const [tabelsLocations, setTabelsLocations] = useState("")
    const [specialsList, setSpecialsList] = useState("")
    const [fromOpening, setFromOpening] = useState("00:00")
    const [toClosing, setToClosing] = useState("00:00")

    const [tablesList, setTablesList] = useState([])

    const [dateToCome, setDateToCome] = useState(new Date())
    const [timeToCome, setTimeToCome] = useState("")
    const [dinners, setDinners] = useState(0)

    const [tabelsLocationsReq, setTabelsLocationsReq] = useState([])
    const [specialsListReq, setSpecialsListReq] = useState([])

    const [timesListApproved, setTimesListApproved] = useState([])
    const [loading, setLoading] = useState(true);

    const [errorsTxts, setErrorsTxts] = useState([]);

    const goToOrderMeRef = useRef();


    useEffect(() => {
        getTblsSpec();

    }, [])

    useEffect(() => {
        setSlectDiners();
    }, [tabelsLocations])


    useEffect(() => {
        setSelectdDinners(dinners);
    }, [dinners])

    useEffect(() => {


    }, [user])

    //מושך פרטי שולחנות של העסק
    const getTblsSpec = async () => {
        let tableSets = await utilsTblOrders.getTableSpecials(currentPage._id)
        setFromOpening(tableSets.fromOpening)
        setToClosing(tableSets.toClosing)
        setTablesList(tableSets.tables)
        setSpecialsList(tableSets.specialsList)
        setTabelsLocations(tableSets.tabelsLocations)

        setLoading(false)
    }

    //בחירת מספר סועדים
    const setSlectDiners = () => {

        let maxTableDinMax = -Infinity;
        let maxTableDinMaxItem = null;

        for (const item of tablesList) {
            const tableDinMaxValue = parseInt(item.tableDinMax, 10);
            if (tableDinMaxValue > maxTableDinMax) {
                maxTableDinMax = tableDinMaxValue;
                maxTableDinMaxItem = item;
            }
        }


        setDispDate(false);
        setDispTime(false);
        setDispDinners(true);
        setDispTableOpts(false);
        setPanelDisp(
            <DinnersNumbSelect
                settingFunc={(val) => setSelectdDinners(val)}
                dinnersSelected={dinners}
                Css={"inputsStyle pointing"}
                maxDinnersNumber={maxTableDinMax}
            />
        )
    }

    //נבחר מספר סועדים
    const setSelectdDinners = (val) => {
        setDinners(val);
        setSelecDate();
        // DispSelected("שולחן", dateToCome);
    }

    //בוחר תאריך הגעה
    const setSelecDate = () => {

        let unavalabledays = getUnavaildDays();
        let unavalableDates = getUnavailableDates();

        setDispDate(true);
        setDispTime(false);
        setDispDinners(false);
        setDispTableOpts(false);

        setPanelDisp(
            <DatePick2
                drpArrCss={"drpArrowWhite"}
                wrpaStyl={"DtPickwrpaStyl"}
                lbl="ל"
                settingFunc={(val) => dateToComeChanged(val)}
                Css="inputsStyle pointing"
                selectedDate={dateToCome}
                noDatesAvailable={unavalabledays}
                noSpecificDates={unavalableDates}
            />
        )
    }

    //נבחר תאריך להזמנה
    const dateToComeChanged = (val) => {
        setDateToCome(val);
        if (format(dateToCome, 'dd.MM.yyyy') !== format(val, 'dd.MM.yyyy')) {
            setTimeToCome("");
            setSelecHour(val, "");
        }
        else {
            setSelecHour(val, timeToCome);
        }

    }

    //בחירת שעת הגעה
    const setSelecHour = (dtCome, tmToCOme) => {

        let tms = getHoursApproveByDay(dtCome);
        setDispDate(false);
        setDispTime(true);
        setDispDinners(false);
        setDispTableOpts(false);
        setPanelDisp(
            <TimesListSelections
                settingFunc={(val) => timeToComeChanged(val)}
                hoursList={tms}
                Css="inputsStyle pointing"
                timeSelected={tmToCOme}

            />
        )
    }

    //נבחרה שעה להזמנה
    const timeToComeChanged = (val) => {
        setTimeToCome(val);
        setSelecSpec();

    }


    //בחירת העדפות שולחן
    const setSelecSpec = () => {
        setDispDate(false);
        setDispTime(false);
        setDispDinners(false);
        setDispTableOpts(true);
        setPanelDisp(
            <SpecialRequests
                settingFunc={(val) => setRequests(val)}
                tabelsLocations={tabelsLocations}
                specialsList={specialsList}
                tabelsLocationsReq={tabelsLocationsReq}
                specialsListReq={specialsListReq}

                Css="inputsStyle pointing"
            />
        )
    }

    //נבחרו מאפייני שולחן
    const setRequests = (respo) => {
        setTabelsLocationsReq(respo.tabelsLocationsReq)
        setSpecialsListReq(respo.specialsListReq)
    }

    //ממיר שעה שמורה ל-"HH:mm:ss" לצורך ההשוואות כאן.
    //normalizeHM מקבל גם "HH:mm" חדש וגם ISO מדור קודם -
    //getTime הישן מחזיר Invalid date על "HH:mm"
    const hmSec = (val) => {
        const hm = MyDateTime.normalizeHM(val);
        return hm === "" ? "00:00:00" : hm + ":00";
    }

    //האם שורת יום מסומנת כסגורה
    const isDayClosed = (dayItm) => {
        if (!dayItm) return true;
        if (dayItm.Closed === true) return true;
        //fallback לנתונים שלא עברו מיגרציה
        return hmSec(dayItm.Open) === "00:00:00" && hmSec(dayItm.Close) === "00:00:00";
    }

    //ימים שהמסעדה לא פתוחה
    //לפי dayItm.Day ולא לפי אינדקס - סדר המערך לא נאכף בשום מקום
    const getUnavaildDays = () => {
        let closedDays = (currentPage.OpeningHours || [])
            .map((dayItm) => isDayClosed(dayItm) ? dayItm.Day : null)
            .filter(day => day !== null && day !== undefined && day !== "");

        return (closedDays)

    }

    //תאריכים ספציפיים שבהם העסק סגור בגלל יום חריג.
    //getUnavaildDays מחזיר שמות ימים ולכן לא יכול לבטא תאריך בודד.
    //מוגבל ל-400 ימים קדימה כדי לא לייצר רשימה חסרת גבול
    const getUnavailableDates = () => {
        const out = [];
        const todayKey = MyDateTime.getIsraelDateKey();

        //חריגות העסק + חריגות גלובליות מהמאסטר.
        //"סגור" מאחת הרמות חוסם, בהתאם לכלל הקדימות ב-resolveChannel
        const list = [
            ...(currentPage.dateSpecilsBlocks || []),
            ...((master && master.dateSpecilsBlocks) || [])
        ];

        for (const exc of list) {
            if (!exc || exc.active === false || !exc.fromDate) continue;

            const ch = exc.channels ? exc.channels.OpeningHours : null;
            if (!ch || ch.Closed !== true) continue;

            const to = exc.toDate || exc.fromDate;

            //פורש את הטווח למפתחות תאריך בודדים
            let cursor = new Date(exc.fromDate + "T12:00:00");
            const last = new Date(to + "T12:00:00");
            if (isNaN(cursor.getTime()) || isNaN(last.getTime())) continue;

            let guard = 0;
            while (cursor <= last && guard < 400) {
                const key = cursor.getFullYear() + '-' +
                    String(cursor.getMonth() + 1).padStart(2, '0') + '-' +
                    String(cursor.getDate()).padStart(2, '0');
                if (key >= todayKey) out.push(key);
                cursor.setDate(cursor.getDate() + 1);
                guard++;
            }
        }

        return out;
    }

    //שעות הפתיחה האפקטיביות לתאריך נתון.
    //
    //אותה פונקציה בדיוק שמחשבת פתוח/סגור בכל המערכת -
    //חריגת העסק דורסת את שעות יום השבוע, ומסגרת המאסטר חותכת
    //את התוצאה. חפיפה ריקה או "סגור" מכל צד -> סגור.
    //
    //val הוא תאריך שנבחר מלוח שנה, ולכן יום השבוע שלו נלקח
    //כמו שהוא ולא מומר ל-timezone
    const getEffectiveHoursForDate = (val) => {
        const key = MyDateTime.getIsraelDateKey(val);
        const day = MyDateTime.getDayOfWeek(val);

        const eff = MyDateTime.effectiveChannelHours(
            currentPage, master, 'OpeningHours', key, day);

        return {
            Day: day,
            Open: eff.Open,
            Close: eff.Close,
            Closed: eff.Closed
        };
    }

    //מושך שעות מאושרות להזמנה על ידי תאריך הבקשה
    //val הוא תאריך שהמשתמש בחר מלוח שנה, ולכן יום השבוע שלו נלקח
    //כמו שהוא ולא מומר ל-timezone - התאריך שנבחר הוא התאריך שהתכוון אליו
    const getHoursApproveByDay = (val) => {

        //השעות האפקטיביות: חריגת העסק דורסת את יום השבוע,
        //ומסגרת המאסטר חותכת את התוצאה
        let opHrs = [getEffectiveHoursForDate(val)];

        //היום סגור - אין מה להציע
        if (isDayClosed(opHrs[0])) {
            return [];
        }



        const intervalInMinutes = 15;

        let theFullTmLstCreated = [];

        // היום הקודם - גם הוא לפי השעות האפקטיביות שלו, כדי שחריגה
        // או מסגרת מאסטר של אותו יום ישפיעו גם על זנב אחרי חצות
        const prevDate = new Date(val);
        prevDate.setDate(prevDate.getDate() - 1);
        let prevOpHrs = getEffectiveHoursForDate(prevDate);

        if (prevOpHrs && !isDayClosed(prevOpHrs)) {
            const prevCloseTime = hmSec(prevOpHrs.Close);
            if (prevCloseTime > "00:00:00" && prevCloseTime <= "05:00:00") { // Check if previous day's close time is after midnight
                const startTimList = generateTimeList("00:00:00", prevCloseTime, intervalInMinutes, fromOpening, toClosing);
                theFullTmLstCreated = theFullTmLstCreated.concat(startTimList);
            }
        }


        const openTime = hmSec(opHrs[0].Open);
        let closeTime = hmSec(opHrs[0].Close);


        let toclsTime = (closeTime >= "00:00:00" && closeTime <= "05:00:00") ? "00:00:00" : toClosing;
        closeTime = (closeTime >= "00:00:00" && closeTime <= "05:00:00") ? "00:00:00" : closeTime;
        closeTime = (closeTime === "00:00:00") ? "23:59:59" : closeTime;


        // Generate time list for the current day
        let currtDayLst = generateTimeList(openTime, closeTime, intervalInMinutes, fromOpening, toClosing);
        // Merge time lists for the previous day and the current day
        theFullTmLstCreated = theFullTmLstCreated.concat(currtDayLst);
        return theFullTmLstCreated;

    }

    //יוצר רשימת שעות אפשריות לבחירה לפי שעות פתיחה של היום הנבחר
    const generateTimeList = (openTime, closeTime, intervalInMinutes, fromOpening, fromClosing) => {
        const timeList = [];
        let currentTime = new Date();
        const closeTimeObj = new Date();

        const [hours, minutes, seconds] = openTime.split(':');
        const [Clhours, Clminutes, Clseconds] = closeTime.split(':');

        const [fromOpeningHours, fromOpeningMinutes] = fromOpening.split(':');
        const [fromClosingHours, fromClosingMinutes] = fromClosing.split(':');

        // Subtract fromOpening time
        currentTime.setHours(parseInt(hours, 10) + parseInt(fromOpeningHours, 10));
        currentTime.setMinutes(parseInt(minutes, 10) + parseInt(fromOpeningMinutes, 10));
        currentTime.setSeconds(seconds);

        closeTimeObj.setHours(parseInt(Clhours, 10) - parseInt(fromClosingHours, 10));
        closeTimeObj.setMinutes(parseInt(Clminutes, 10) - parseInt(fromClosingMinutes, 10));
        closeTimeObj.setSeconds(Clseconds);

        while (currentTime <= closeTimeObj) {
            timeList.push(currentTime.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false }));

            // Clone the currentTime object before modifying it
            const newTime = new Date(currentTime);

            // Update the cloned object
            newTime.setMinutes(newTime.getMinutes() + intervalInMinutes);

            // Update currentTime with the cloned object
            currentTime = newTime;
        }

        return timeList;
    };

    const goToOrderMe = () => {
        let err = [];

        if (timeToCome === "") {
            err.push("יש לבחור שעה להזמנה")
        }
        if (dinners === 0) {
            err.push("יש לציין מספר סועדים להזמנה")
        }
        if (err.length > 0)
            setErrorsTxts(err)
        else {
            if (user?._id != null) {

                let itm = {
                    buisId: currentPage._id,
                    buissName: currentPage.buissName,
                    dinners,
                    timeToCome,
                    dateToCome,
                    clientName: user.firstName + " " + user.lastName,
                    clientPhone: user.phone,
                    remarks: "",
                    tabelsLocationsReq: tabelsLocationsReq,
                    specialsListReq: specialsListReq

                }

                setThePopUp(
                    <PopUpTheComp
                        cssStyl={"onTopOfAll OrderTblPop"}
                        btnFStyle={"fatInBtn"}
                        closePop={() => { setThePopUp() }}
                        Title={[""]}
                        theInsideComp={
                            <ApprovedOrdr
                                tblOrdrItem={itm}
                                closeMeFuc={() => setThePopUp()}
                                cancelClick={() => setThePopUp()}
                                okClick={(itmBk) => ordrGo(itmBk)}

                            />}
                    />
                )
            }
            else {
                loginFirst();
            }

        }
    }

    //הכל מאושר, הזמן את השולחן
    const ordrGo = async (itm) => {
        setThePopUp();
        let ordBk = await utilsTblOrders.orderMyTable(itm);

        try {
            if (ordBk.msg === "approved") {
                setThePopUp(
                    <Table_Order_Confirmd
                        tblOrderNUM={ordBk.orderNumber}
                        okClick={() => { setThePopUp(); props.closeMe() }}
                    />)
            }
        }
        catch {

        }
    }

    const loginFirst = () => {
        setThePopUp(
            <PopUpClearComp
                popFullComp={"specialPopComp onTopOfAll"}
                cssStyl={"noPadding "}
                btnFStyle={"fatInBtn"}
                closePop={() => setThePopUp()}
                insideCss={"noPadding "}
                theInsideComp={
                    <LoginPage
                        theInsideComp={""}
                        backFunc={true}
                        closeMeFuc={() => setThePopUp()}
                        shoTopStrp={(tf) => { }}
                        scrollToTop={(stUp) => { }} />
                } />)
    }

    const showClntDetails = () => {
        setThePopUp();
        if (goToOrderMeRef.current) {
            goToOrderMeRef.current.click();
        }
    }

    return (
        <div className="buisReservationPop">
            {
                !loading && <>

                    <div className={"fullRow overflowHid spaceButtomBig buisReservationPopBtns"}>
                        <h3 style={{ color: "black", textAlign: "center" }} className={"noMargin"}>הזמנת מקום במסעדה</h3>
                        <div className={"reservationBtWrap onRight"}>
                            <div onClick={() => setSlectDiners()}
                                className={`reservationBigBtn ${dispDinners ? "selectedINColor" : ""} ${(dinners !== 0) ? "smalPad" : ""} pointing`}>
                                {dinners === 0 ? "סועדים" : <><p>{dinners}</p><p>סועדים</p></>}
                            </div>
                        </div>

                        <div className={"reservationBtWrap onRight"}>
                            <div onClick={() => setSelecDate()}
                                className={`reservationBigBtn 
                        ${dispDate ? "selectedINColor" : ""} ${!isToday(dateToCome) ? "smalPad" : ""} pointing`}>
                                {isToday(dateToCome) ? "היום" : <><p>לתאריך</p><p> {format(dateToCome, 'dd.MM.yyyy')}</p></>}

                            </div>
                        </div>
                        <div className={"reservationBtWrap onRight"}>
                            <div onClick={() => setSelecHour(dateToCome, timeToCome)}
                                className={`reservationBigBtn ${dispTime ? "selectedINColor" : ""} ${(timeToCome !== "") ? "smalPad" : ""} pointing`}>
                                {timeToCome === "" ? "שעה" : <><p>בשעה</p><p>{timeToCome}</p></>}
                            </div>
                        </div>

                        <div className={"reservationBtWrap onRight"}>
                            <div onClick={() => setSelecSpec()}
                                className={`reservationBigBtn ${dispTableOpts ? "selectedINColor" : ""} pointing`}>העדפות</div>
                        </div>
                    </div>

                    <div className="reservationDispPanel">
                        {panelDisp}
                    </div>
                    <div className="fullRow margTopBig resrvationOrdBtnWrap">
                        <div ref={goToOrderMeRef}
                            onClick={() => goToOrderMe()} className="resrvationOrdMeBtn resrvationOrdMeBtn_in pointing">
                            הזמן
                        </div>
                        {errorsTxts.length > 0 &&
                            <div className={"spaceTopBig"}>
                                {errorsTxts.map((it, indx) => {
                                    return (
                                        <p key={indx} className={"fullRow overflowHid errorLine centerText MbigFont bold InRed"}>{it}</p>
                                    )
                                })}
                            </div>
                        }
                    </div>
                    {thePopUp}
                </>
            }
        </div >
    )
}

export default TblOrderReservation;
